import { PUBLIC_URL } from '../../utils/constants';

export default {
  SCHOOL_CLINIC_LIST: `${PUBLIC_URL}/school-clinic`,
  SCHOOL_CLINIC_ADD: `${PUBLIC_URL}/school-clinic/add`,
  SCHOOL_CLINIC_EDIT: `${PUBLIC_URL}/school-clinic/edit/:id`,
  SCHOOL_CLINIC_DETAILS: `${PUBLIC_URL}/school-clinic/:id`,
};
